import Fuse, { IFuseOptions } from 'fuse.js';

const DEFAULT_FUZZY_THRESHOLD = 0.55;

export const createFuzzySearcher = <T>(items: T[], options: IFuseOptions<T>) => {
  const fuse = new Fuse(items, { threshold: DEFAULT_FUZZY_THRESHOLD, ...options });
  return (query: string) => {
    if (!query.trim()) return items;
    return fuse.search(query).map((result) => result.item);
  };
};

const fuzzySearch = <T>(items: T[], query: string, options: IFuseOptions<T>): T[] => {
  if (!query.trim()) return items;
  const fuse = new Fuse(items, { threshold: DEFAULT_FUZZY_THRESHOLD, ...options });
  return fuse.search(query).map((result) => result.item);
};

export default fuzzySearch;
